import { IGetPickupDTO } from '@/models/regions.model';

class GetPickupsDTO implements IGetPickupDTO {
  region_id?: string;
  settlement_id?: string;
  address?: string;
  phone?: string;
  is_active?: string;
  is_default?: string;
  page: number;
  limit?: number;

  constructor({
    region_id,
    settlement_id,
    address,
    phone,
    is_default = '',
    is_active = '',
    page,
  }: {
    region_id?: string;
    settlement_id?: string;
    address?: string;
    phone?: string;
    is_active?: boolean | string;
    is_default?: boolean | string;
    page: number;
    limit?: number;
  }) {
    this.region_id = region_id;
    this.settlement_id = settlement_id;
    this.address = address;
    this.is_active = is_active === '' ? undefined : is_active ? '1' : '0';
    this.is_default = is_default === '' ? undefined : is_default ? '1' : '0';
    this.phone = phone;
    this.page = page ?? 1;
    this.limit = 10;
  }
}

export default GetPickupsDTO;
